import { NavigationBar } from '@/components/NavigationBar/NavigationBar'
import { NewBackofficeBanner } from '@/components/NewBackofficeBanner/NewBackofficeBanner'
import { Sidebar } from '@/components/Sidebar/Sidebar'
import { Box, Flex } from '@chakra-ui/react'
import { Content, Shell } from '@hivemq/ui-library'
import type { PropsWithChildren } from 'react'

export function Layout({ children }: Readonly<PropsWithChildren>) {
  return (
    <Flex direction="column" h="100vh">
      <NewBackofficeBanner />
      <Box flex="1" minH={0} css={{ '& > div': { height: '100%' } }}>
        <Shell.Root sidebarWidth="var(--sidebar-width)">
          <NavigationBar />
          <Sidebar />

          <Content.Root as="main">{children}</Content.Root>
        </Shell.Root>
      </Box>
    </Flex>
  )
}
